export interface IUseDates {
    getDate: getDateFunc,
}

type getDateFunc = (date: string) => string

export const useDates = (): IUseDates => {

    const getDate = (date: string): string => {
        const stamp = new Date(date);
        const formatter = new Intl.DateTimeFormat("de-DE", { // <- re-use me
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        })
        return formatter.format(stamp);
    }


    return {
        getDate,
    }
}
